
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"182","height":"368"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M159.3 368H24.7C12.2 368 2 357.8 2 345.3V22.7C2 10.2 12.2 0 24.7 0h134.7C171.8 0 182 10.2 182 22.7v322.7c0 12.4-10.2 22.6-22.7 22.6zM24.7 2C13.3 2 4 11.3 4 22.7v322.7c0 11.4 9.3 20.7 20.7 20.7h134.7c11.4 0 20.7-9.3 20.7-20.7V22.7C180 11.3 170.7 2 159.3 2H24.7zM0 45h2v18H0zM0 79h2v27H0zM0 111h2v27H0z"}}),_c('path',{attrs:{"d":"M105 28H78c-1.7 0-3-1.3-3-3s1.3-3 3-3h27c1.7 0 3 1.3 3 3s-1.3 3-3 3zm-27-4c-.6 0-1 .4-1 1s.4 1 1 1h27c.6 0 1-.4 1-1s-.4-1-1-1H78zM63 29c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM91 15c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm0-4c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zM90 358c-7.7 0-14-6.3-14-14s6.3-14 14-14 14 6.3 14 14-6.3 14-14 14zm0-26c-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12-5.4-12-12-12z"}}),_c('g',[_c('path',{attrs:{"d":"M15 45h154v278H15z","opacity":".1"}}),_c('path',{attrs:{"d":"M170 324H14V44h156v280zm-154-2h152V46H16v276z"}})]),_c('g',[_c('path',{attrs:{"d":"M14 322l61.5-110.6m32.1-57.7L168 45","opacity":".1"}}),_c('path',{attrs:{"d":"M14.9 322.5l-1.7-1 61.5-110.6 1.7 1-61.5 110.6zm93.5-168.3l-1.7-1 60.4-108.7 1.7 1-60.4 108.7z"}})])])
          )
        }
      }
    